import Tooltip from "@/Components/Tooltip/Tooltip";
import useCommon from "@/shared/hooks/useCommon";
import useTableSessionHook from "@/shared/hooks/useTableSessionHook";
import { RestaurantTable } from "@/shared/utils/interfaces";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import { cn } from "@/shared/utils/cn";

const PosTable = ({
  active = -1,
  disable = [],
  setTable,
  table,
  canChooseSession = true,
  mustChooseSession = false,
  forceNoSession = undefined,
  card = false,
}: {
  forceNoSession?: boolean;
  active?: number | number[];
  setTable: Function;
  table: RestaurantTable;
  canChooseSession?: boolean;
  mustChooseSession?: boolean;
  disable?: number[];
  card?: boolean;
}) => {
  const { session } = useTableSessionHook(table.item_id);
  const t = useCommon();
  const isWaiter = useIsWaiter();
  const useCard = card || isWaiter;
  const hasSession =
    forceNoSession === undefined ? session !== undefined : forceNoSession;
  const isActive = Array.isArray(active)
    ? active.includes(table.item_id)
    : table.item_id === active;
  const cursor = disable.includes(table.item_id)
    ? "not-allowed"
    : mustChooseSession
      ? hasSession
        ? "pointer"
        : "not-allowed"
      : canChooseSession
        ? "pointer"
        : hasSession
          ? "not-allowed"
          : "pointer";
  const backgroundColor = isActive
    ? "var(--success)"
    : hasSession
      ? "var(--error)"
      : "var(--primary)";

  const onSelect = () => {
    if (mustChooseSession) {
      return hasSession ? setTable(isActive ? -1 : table) : undefined;
    }
    canChooseSession
      ? setTable(table)
      : !hasSession
        ? setTable(isActive ? -1 : table)
        : undefined;
  };

  if (useCard) {
    return (
      <button
        type="button"
        onClick={onSelect}
        disabled={cursor === "not-allowed"}
        className={cn(
          "relative flex min-h-36 w-full flex-col items-center justify-center rounded-2xl border-2 p-3 text-center",
          isActive && "border-success bg-success shadow-md",
          !isActive && hasSession && "border-error/20 bg-error/10 text-error",
          !isActive &&
            !hasSession &&
            "bg-green-100  text-dark border-green-200 hover:bg-green-200 hover:shadow-sm",
          cursor === "not-allowed" && "opacity-40"
        )}
      >
        <span
          className={cn(
            "absolute top-2 right-2 flex h-7 min-w-7 items-center justify-center rounded-full px-1.5",
            isActive ? "bg-white/20 text-white" : "bg-black/10 text-current"
          )}
        >
          {table.amount_of_seats}
        </span>
        <div>
          {t("tableNumber")}: {table.table_number}
        </div>
      </button>
    );
  }
  return (
    <Tooltip content={t(hasSession ? "occupiedTable" : "availableTable")}>
      <div>
        <div
          onClick={onSelect}
          key={table.item_id}
          className="relative flex h-40 w-40 flex-[0_0_10rem] items-center justify-center font-black text-white"
          style={{ cursor, backgroundColor }}
        >
          <Tooltip content={`${t("seatsPlaceholder")}`}>
            <div>
              <div className="absolute right-0 flex size-8 items-center justify-center ">
                {table.amount_of_seats}
              </div>
            </div>
          </Tooltip>
          <div>{table.table_number}</div>
        </div>
      </div>
    </Tooltip>
  );
};

export default PosTable;
